import { render, staticRenderFns } from "./hrd-add-program.vue?vue&type=template&id=6a06a434&scoped=true"
import script from "./hrd-add-program.vue?vue&type=script&lang=js"
export * from "./hrd-add-program.vue?vue&type=script&lang=js"
import style0 from "./hrd-add-program.vue?vue&type=style&index=0&id=6a06a434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a06a434",
  null
  
)

export default component.exports